import React from "react";
import { Builder } from "@builder.io/react";

import BuilderStringInput from "@utils/BuilderInputs/BuilderStringInput";
import SignupFormDrip, {
  SignupFormDripType,
} from "@components/BuilderComponents/SignupFormDrip";

const SignupFormDripWrapper: React.FC<SignupFormDripType> = props => {
  return (
    <SignupFormDrip steps={props?.steps} lastStepCta={props?.lastStepCta} />
  );
};

export default SignupFormDripWrapper;

export const RegisterSignupFormDrip = () => {
  Builder.registerComponent(SignupFormDripWrapper, {
    name: "signup-form-drip",
    inputs: [
      {
        name: "lastStepCta",
        type: "string",
        helperText:
          "Copy of CTA on last step of form. If left blank, defaults to “Start My Free Trial Now”",
      },
      {
        name: "steps",
        type: "list",
        subFields: [
          new BuilderStringInput("headline", { defaultValue: "" }),
          new BuilderStringInput("subcopy", { defaultValue: "" }),
          {
            type: "list",
            name: "fields",
            subFields: [
              new BuilderStringInput("field", {
                defaultValue: "firstName",
                enum: [
                  "agreement",
                  "email",
                  "firstName",
                  "lastName",
                  "password",
                  "phone",
                  "profession",
                  {
                    label: "addQuestion",
                    value: "questions",
                  },
                  "offer",
                ],
              }),
              {
                name: "questionAttributes",
                type: "object",
                showIf: `options.get('field') === 'questions'`,
                bubble: true,
                subFields: [
                  {
                    name: "questionTitle",
                    type: "string",
                    helperText:
                      "Copy to be displayed as question on sign up form.",
                  },
                  {
                    name: "questionDropdownOptions",
                    type: "list",
                    max: 1,
                    min: 1,
                    helperText:
                      "Options to be displayed in dropdown on sign up form.",
                    subFields: [new BuilderStringInput("Dropdown")],
                  },
                  {
                    name: "questionType",
                    type: "select",
                    enum: [
                      {
                        label: "Dropdown",
                        value: "dropdown",
                      },
                      {
                        label: "Multiple select",
                        value: "multipleSelect",
                      },
                    ],
                  },
                  {
                    name: "questionName",
                    helperText:
                      "Copy to be displayed in Mixpanel event describing field.",
                    type: "string",
                    required: true,
                  },
                  {
                    name: "questionOptional",
                    helperText: "Turning on makes question optional",
                    type: "boolean",
                    defaultValue: false,
                  },
                ],
              },
              {
                name: "offerAttributesOne",
                friendlyName: "Offer Attributes 1",
                type: "object",
                showIf: `options.get('field') === 'offer'`,
                bubble: false,
                subFields: [
                  {
                    name: "title",
                    type: "string",
                    friendlyName: "Offer 1",
                  },
                  {
                    name: "copy",
                    type: "longText",
                    friendlyName: "Offer 1 Subcopy",
                  },
                  {
                    name: "promoCode",
                    type: "string",
                    friendlyName: "Offer 1 Promo Code",
                    helperText:
                      "Promo code that will be dropped if selected. For a standard trial leave blank",
                  },
                ],
              },
              {
                name: "defaultOfferOne",
                type: "boolean",
                friendlyName: "Offer 1 Default",
                helperText: "Determines which offer the user sees by default",
                defaultValue: true,
                showIf: `options.get('field') === 'offer'`,
              },
              {
                name: "offerAttributesTwo",
                friendlyName: "Offer Attributes 2",
                type: "object",
                showIf: `options.get('field') === 'offer'`,
                bubble: true,
                subFields: [
                  {
                    name: "title",
                    type: "string",
                    friendlyName: "Offer 2",
                  },
                  {
                    name: "copy",
                    type: "longText",
                    friendlyName: "Offer 2 Subcopy",
                  },
                  {
                    name: "promoCode",
                    type: "string",
                    friendlyName: "Offer 2 Promo Code",
                    helperText:
                      "Promo code that will be dropped if selected. For a standard trial leave blank",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  });
};
